import { Textarea } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

type TrainingsNotesProps = {
  notes: string | undefined
  onClick: () => void
}

const TrainingsNotes = ({ notes, onClick }: TrainingsNotesProps) => {
  const { t } = useTranslation()

  return (
    <Textarea
      label={t('Notes')}
      type="text"
      value={notes}
      maxLength={255}
      rows={3}
      readOnly
      onClick={onClick}
      title={t('Click to edit notes')}
      id="notes"
    />
  )
}

export default TrainingsNotes
